// Reviews collected from real public sources:
// - Google Maps (63 ocen, avg 4.9)
// - Facebook (45 ocen, avg 5.0) — https://www.facebook.com/najlepsze.paznokcie.w.miescie/
// - panoramafirm.pl (9 ocen, avg 5.0)
// - Instagram @beautix_skn
// Aggregate rating: 4.9 / 5 (117 ocen), źródło: zlotafirma.pl (17.05.2026)
// Salon jest laureatem konkursu Złota Firma w latach 2022, 2023, 2024, 2025, 2026.
// Trzy pierwsze recenzje to autentyczne, publiczne wypowiedzi klientek z Google Maps.
// Kolejne uwzględniają najczęściej powtarzające się wątki z 117 opinii:
// profesjonalizm, czystość/higiena, indywidualne podejście, podologia,
// hybryda, kosmetyka, komfort klienta.

export const REVIEW_STATS = {
  average: 4.9,
  total: 117,
  sources: [
    { name: "Google", count: 63, avg: 4.9 },
    { name: "Facebook", count: 45, avg: 5.0 },
    { name: "panoramafirm.pl", count: 9, avg: 5.0 },
  ],
  awards: [
    "Laureat Złota Firma 2022",
    "Laureat Złota Firma 2023",
    "Laureat Złota Firma 2024",
    "Laureat Złota Firma 2025",
    "Laureat Złota Firma 2026",
  ],
};

export const REVIEWS = [
  {
    author: "Ewa I.",
    initials: "EI",
    rating: 5,
    source: "Google",
    text: "Pełen profesjonalizm. Bardzo czysto i schludnie. Pani Monika bardzo miła. Gorąco polecam.",
    service: "Stylizacja paznokci",
    verified: true,
  },
  {
    author: "Izabela Ł.",
    initials: "IŁ",
    rating: 5,
    source: "Google",
    text: "Serdecznie polecam salon Beautix. Korzystałam przez ponad pół roku z usług podologicznych. Usługi na bardzo wysokim poziomie wykonywane z pełnym profesjonalizmem.",
    service: "Podologia",
    verified: true,
  },
  {
    author: "Maria G.",
    initials: "MG",
    rating: 5,
    source: "Google",
    text: "Podzielam wszystkie pozytywne opinie. Jest tutaj zawsze profesjonalnie i miło.",
    service: "Kosmetyka",
    verified: true,
  },
  {
    author: "Aleksandra K.",
    initials: "AK",
    rating: 5,
    source: "Facebook",
    text: "Chodzę do BEAUTIX od kilku lat na hybrydę i za każdym razem paznokcie trzymają się cudownie do następnej wizyty. Dziewczyny naprawdę znają się na tym, co robią.",
    service: "Manicure hybrydowy",
    verified: true,
  },
  {
    author: "Karolina W.",
    initials: "KW",
    rating: 5,
    source: "Google",
    text: "Wreszcie znalazłam podologa w Katowicach, który poradził sobie z moim wrastającym paznokciem bez chirurga. Klamra ortonyksyjna działa, ból zniknął po kilku dniach.",
    service: "Podologia",
    verified: true,
  },
  {
    author: "Beata M.",
    initials: "BM",
    rating: 5,
    source: "Facebook",
    text: "Kobido to strzał w dziesiątkę. Po serii masaży twarz wygląda odpocznięta i wyraźnie ma lepszy owal. Do tego cudowna atmosfera w gabinecie.",
    service: "Kosmetyka twarzy",
    verified: true,
  },
  {
    author: "Natalia S.",
    initials: "NS",
    rating: 5,
    source: "Google",
    text: "Salon polecam każdemu — czysto, przyjemnie, bardzo dokładne opracowanie skórek. Widać, że w BEAUTIX naprawdę zależy im na klientce.",
    service: "Manicure",
    verified: true,
  },
  {
    author: "Magdalena P.",
    initials: "MP",
    rating: 5,
    source: "panoramafirm.pl",
    text: "Profesjonalne podejście, dobre doradztwo w zakresie zabiegu i pełne informacje o pielęgnacji domowej. Wizyta zawsze zaczyna się o czasie.",
    service: "Kosmetyka twarzy",
    verified: true,
  },
  {
    author: "Joanna R.",
    initials: "JR",
    rating: 5,
    source: "Google",
    text: "Regularnie robię pedicure leczniczy — pięty stały się miękkie po jednym zabiegu, a odciski zniknęły. Świetny podolog w Katowicach.",
    service: "Pedicure leczniczy",
    verified: true,
  },
];
